function loadCache() {
  const cached = localStorage.getItem('schema_tables');
  return cached ? JSON.parse(cached) : [];
}

function saveCache(tables) {
  localStorage.setItem('schema_tables', JSON.stringify(tables.sort((a, b) => a.table_name.localeCompare(b.table_name))));
}

function schemaQualify(name) {
  return name.includes('.') ? name : `public.${name}`;
}

async function fetchTableConfigs(tableNames) {
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    resource: `${process.env.VUE_APP_API4_DOMAIN}/schema/tableConfig?table_name=${tableNames.join(',')}`
  };
  try {
    const response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
      method: 'GET',
      headers,
      credentials: 'include'
    });
    if (response.status === 403) {
      const data = await response.json();
      alert(data.message);
      window.location.href = '/login';
      return null;
    }
    const data = await response.json();
    return data.message || [];
  } catch (e) {
    console.error('[schemaCache] fetch error', e);
    return [];
  }
}

export async function getTableConfigs(tableNames) {
  let cachedSchema = loadCache();
  const missing = [];
  const result = {};

  for (const tableName of tableNames) {
    const cachedTableInfo = cachedSchema.find(tableInfo => schemaQualify(tableInfo.table_name) === schemaQualify(tableName));
    if (cachedTableInfo) {
      result[tableName] = cachedTableInfo;
    } else {
      missing.push(tableName);
    }
  }

  if (missing.length > 0) {
    const fetched = await fetchTableConfigs(missing.map(schemaQualify));
    if (fetched) {
      // Load cache again to avoid duplicates: this could happen if we have concurrent requests for table info
      cachedSchema = loadCache();
      const newEntries = fetched.filter(fetchedTableInfo => !cachedSchema.find(cachedTableInfo => cachedTableInfo.table_name === fetchedTableInfo.table_name));
      saveCache([...cachedSchema, ...newEntries]);  // ... is JavaScript for expanding array into individual elements
      for (const tableConfig of fetched) {
        const originalName = missing.find(name => schemaQualify(name) === tableConfig.table_name) || tableConfig.table_name;
        result[originalName] = tableConfig;
      }
      // Some views are conglomerates of tables, and don't have corresponding tables, so only throw error if a _view is missing
      const notFound = missing.filter(name => !result[name] && name.endsWith('_view'));
      if (notFound.length > 0) {
        alert(`Your work may not be saved!\nPlease alert tech that the following tables are missing from schema_table_json and need to be added:\n\n${notFound.map(schemaQualify).join('\n')}`);
      }
    }
  }

  return result;
}
